var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input-money",
      class: {
        focus: _vm.onFocus,
        "align-center": _vm.$attrs.align === "center",
      },
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.t("filter.currency")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "number" },
        domProps: { value: _vm.value },
        on: {
          change: _vm.changeHandle,
          blur: function ($event) {
            _vm.onFocus = false
          },
          focus: _vm.focusHandle,
          input: function ($event) {
            if ($event.target.composing) return
            _vm.value = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("label", [
        _vm.$attrs.align === "center"
          ? _c("span", [_vm._v(_vm._s(_vm.t("filter.currency")))])
          : _vm._e(),
        _vm._v(_vm._s(_vm.formatMoney(this.value))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }